import { render, staticRenderFns } from "./Cpyhonor.vue?vue&type=template&id=56bbbe70&scoped=true"
import script from "./Cpyhonor.vue?vue&type=script&lang=js"
export * from "./Cpyhonor.vue?vue&type=script&lang=js"
import style0 from "./Cpyhonor.vue?vue&type=style&index=0&id=56bbbe70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bbbe70",
  null
  
)

export default component.exports